<template>
	<div v-if="activities" class="py-8">
		<Timeline :value="allActivities" class="-ml-[100%]">
			<template #content="slotProps">
				<HistoryTimelineCard :item="slotProps.item" :index="slotProps.index"/>
			</template>
		</Timeline>
	</div>
</template>

<script>
import { mapStores } from "pinia";
import { useDevicesStore } from "@/stores/devices.js";
import HistoryTimelineCard from "@/Components/HistoryTimelineCard.vue";

export default {
	name: "DeviceHistoryView",
	components: {HistoryTimelineCard},
	data() {
		return {
			activities: undefined,
		}
	},
	computed: {
		...mapStores(useDevicesStore),
		allActivities() {
			return [
				...this.activities,
			].sort((a, b) => Date.parse(b.created_at) - Date.parse(a.created_at));
		},
	},
	methods: {
		async refreshDevice() {
			return this.devicesStore.showDevice(this.$route.params.device, {
				fields: {devices: 'id'},
				include: ['activities.causer'],
			});
		},
	},
	watch: {
		'$route.params.device': {
			async handler(newValue, oldValue) {
				if (newValue) {
					if (this.$route.params.device === 'NEW') {
						this.activities = [];
					} else {
						const response = (await this.refreshDevice());
						this.activities = response.activities;
					}
				} else {
					this.activities = undefined;
				}
			},
			immediate: true,
		}
	},
}
</script>